export default "__VITE_ASSET__7a2c7ff3__"